import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TooltipButton } from 'common/react/components/tooltip-button';
import { BENCHMARKING } from 'common/react/components/benchmarking/config/benchmarking';
import { ConditionalWrapper } from 'common/react/components/ConditionalWrapper';

const StatsTableBodyStandardCell = ({
    cellIndex,
    cellProps,
    cell,
    row,
    value,
    benchmark,
    isUpcoming,
    valueWrapper,
    primaryTooltipComponent,
    getCellId,
    getCellTitle
}) => {
    const showTooltip =
        primaryTooltipComponent &&
        !isUpcoming &&
        value !== 'NP' &&
        value !== 'B';

    let displayValue = '';
    if (value !== 'NP' && !isUpcoming) {
        displayValue = value;
    }

    const renderCellInnerWrapper = (children) => (
        <div
            className={classNames(
                'stats-table__cell-inner-wrapper',
                { 'stats-table__cell-inner-wrapper--empty': !value },
                {
                    'stats-table__cell-inner-wrapper--bye':
                        value === 'B' && !isUpcoming
                },
                {
                    'stats-table__cell-inner-wrapper--not-played':
                        value === 'NP'
                },
                { 'stats-table__cell-inner-wrapper--upcoming': isUpcoming }
            )}
        >
            {children}
        </div>
    );

    return (
        <td
            {...cellProps}
            className={classNames('stats-table__cell', {
                'stats-table__cell--sorted': cell.column.isSorted,
                'stats-table__cell--elite':
                    benchmark === BENCHMARKING.ELITE.KEY,
                'stats-table__cell--above-avg':
                    benchmark === BENCHMARKING.ABOVE_AVERAGE.KEY,
                'stats-table__cell--avg':
                    benchmark === BENCHMARKING.AVERAGE.KEY,
                'stats-table__cell--below-avg':
                    benchmark === BENCHMARKING.BELOW_AVERAGE.KEY
            })}
            key={cellIndex}
        >
            <ConditionalWrapper
                condition={valueWrapper}
                wrapper={renderCellInnerWrapper}
            >
                {showTooltip ? (
                    <TooltipButton
                        id={getCellId(row, cell)}
                        title={getCellTitle(row, cell)}
                        hideArrow
                        noPadding
                        externalTooltip
                        showOnHover={false}
                        direction="below"
                        primaryTooltipContent={primaryTooltipComponent(
                            row,
                            cell,
                            benchmark
                        )}
                        classNames={{
                            component: 'stats-table__cell-button-wrapper',
                            button: 'stats-table__cell-button'
                        }}
                    >
                        {value}
                    </TooltipButton>
                ) : (
                    <>{displayValue}</>
                )}
            </ConditionalWrapper>
        </td>
    );
};

export default StatsTableBodyStandardCell;

StatsTableBodyStandardCell.propTypes = {
    cellIndex: PropTypes.number.isRequired,
    cellProps: PropTypes.object.isRequired,
    cell: PropTypes.object.isRequired,
    row: PropTypes.object.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    benchmark: PropTypes.string,
    isUpcoming: PropTypes.bool.isRequired,
    valueWrapper: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    primaryTooltipComponent: PropTypes.func,
    getCellId: PropTypes.func.isRequired,
    getCellTitle: PropTypes.func.isRequired
};
